import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MobileUpdateModal from 'component/mobileUpdate/MobileUpdateModal'

const REMOVE = 'MOBILE_UPDATE_REMOVE'
const UPDATE = 'MOBILE_UPDATE_UPDATE'
let modalType = REMOVE

class MobileUpdateTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      missionModal: false,
      mobileUpdate: {},
    }

    this.openRemoveModal = this.openRemoveModal.bind(this)
    this.openUpdateModal = this.openUpdateModal.bind(this)
    this.toogleModal = this.toogleModal.bind(this)
    this.renderMobileUpdateModal = this.renderMobileUpdateModal.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleUpdate = this.handleUpdate.bind(this)
    this.renderRows = this.renderRows.bind(this)
  }

  openRemoveModal(mobileUpdate) {
    modalType = REMOVE
    this.setState({ mobileUpdate })
    this.toogleModal()
  }

  openUpdateModal(mobileUpdate) {
    modalType = UPDATE
    this.setState({ mobileUpdate })
    this.toogleModal()
  }

  toogleModal() {
    this.setState({ missionModal: !this.state.missionModal })
  }

  renderMobileUpdateModal() {
    const { missionModal } = this.state
    const { translate } = this.props

    if (!missionModal) {
      return
    }

    let props = {}

    if (modalType === UPDATE) {
      props = {
        modalType: UPDATE,
        translate,
        closeModal: this.toogleModal,
        onSubmit: this.handleUpdate,
      }
    } else if (modalType === REMOVE) {
      props = {
        modalType: REMOVE,
        translate,
        closeModal: this.toogleModal,
        onSubmit: this.handleDelete,
      }
    }

    return <MobileUpdateModal {...props} />
  }

  handleDelete() {
    const { delMobileUpdate } = this.props
    const { mobileUpdate } = this.state

    delMobileUpdate(mobileUpdate)
    this.toogleModal()
  }

  handleUpdate() {
    const { onSubmit } = this.props
    const { mobileUpdate } = this.state

    // Sets indicator to 'updated'
    mobileUpdate.inUpdate = 1

    onSubmit(mobileUpdate)
    this.toogleModal()
  }

  renderRows(mobileUpdate, index) {
    return (
      <tr key={index}>
        <td className='align-left hidden-column overflow-hidden-column overflow-column-text'>
          {mobileUpdate.dsBranch ? mobileUpdate.dsBranch : '-'}
        </td>
        <td className='align-left overflow-hidden-column overflow-column-text'>
          {mobileUpdate.dsMission ? mobileUpdate.dsMission : '-'}
        </td>
        <td className='align-left overflow-hidden-column overflow-column-text'>
          {mobileUpdate.dsLdap ? mobileUpdate.dsLdap : '-'}
        </td>
        <td className='align-center overflow-hidden-column'>
          {mobileUpdate.idVersion}
        </td>

        <td className='align-center'>
          {mobileUpdate.inUpdate === 0 ? (
            <a
              id={`view-mission-${index}`}
              role='button'
              onClick={() => this.openUpdateModal(mobileUpdate)}
            >
              <i className='glyph glyph-refresh icon-size' />
            </a>
          ) : (
            <a id={`view-mission-${index}`} className='cursor-block'>
              <i className='glyph glyph-grey glyph-checked icon-size' />
            </a>
          )}
        </td>
        <td className='align-center'>
          <a
            id={`edit-mission-${index}`}
            role='button'
            className={mobileUpdate.inUpdate !== 0 ? 'hide-glyph' : ''}
            onClick={() => this.openRemoveModal(mobileUpdate)}
          >
            <i className='glyph glyph-red glyph-trash-can icon-size' />
          </a>
        </td>
      </tr>
    )
  }

  render() {
    const { mobileUpdates, translate } = this.props

    return (
      <div className='MenuMissionTable'>
        <table className='table table-zebra margin-top-double table-layout-fixed'>
          <thead>
            <tr>
              <th className='align-left hidden-column overflow-hidden-column'>
                {translate('mobile-update.branch')}
              </th>
              <th className='align-left overflow-hidden-column'>
                {translate('mobile-update.profile')}
              </th>
              <th className='align-left overflow-hidden-column'>
                {translate('mobile-update.code-user')}
              </th>
              <th className='align-center overflow-hidden-column'>
                {translate('mobile-update.version')}
              </th>
              <th className='align-center'>
                {translate('mobile-update.update')}
              </th>
              <th className='align-center'>
                {translate('mobile-update.remove')}
              </th>
            </tr>
          </thead>
          <tbody>{mobileUpdates.map(this.renderRows)}</tbody>
        </table>

        {this.renderMobileUpdateModal()}
      </div>
    )
  }
}

MobileUpdateTable.propTypes = {
  mobileUpdates: PropTypes.array.isRequired,
  translate: PropTypes.func.isRequired,
  delMobileUpdate: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}

export default MobileUpdateTable
